import {useContext} from 'react'
import {AppStateContext} from '../contexts'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'

const useAppState = () => {
    const {res} = useServerContext()
    const state =
        useContext(AppStateContext) ||
        res?.locals.state ||
        window?.__PRELOADED_STATE__.__STATE_MANAGEMENT_LIBRARY

    return {
        preferences: {...state.preferences},
        navigation: {...state.navigation}
    }
}

export default useAppState
